import Tooltip from "rc-tooltip";
import React from "react";
import { useIntl } from "react-intl";

type Message = {
  id: string;
  defaultMessage: string;
};

export const OneWayIndicator = (oneWayFare: Message) => {
  const intl = useIntl();
  return (
    <Tooltip
      placement="leftBottom"
      trigger={["hover", "click"]}
      overlay={intl.formatMessage(oneWayFare)}
      overlayClassName="brands-table-service-name-tooltip"
    >
      <span
        id="two-one-way-symptom"
        style={{ fontSize: "11pt", paddingLeft: 6 }}
      >
        2OW
      </span>
    </Tooltip>
  );
};
